import { writable, get } from 'svelte/store';
import { goto } from '$app/navigation';

const store: {
  auth_user?: any;
  user?: User_v1;
  company?: Company_v1;
  charity?: Charity_v2;
  org?: Org_v1;
  origin?: string;
  companyState: CompanyState | undefined;
  orgState: CompanyState | undefined;
  temp_context: any;
} = {
  auth_user: undefined,
  user: undefined,
  company: undefined,
  charity: undefined,
  org: undefined,
  origin: undefined,
  companyState: undefined,
  orgState: undefined,
  temp_context: {}
};

export const appState = writable(store);
